import { Routes, Route, Navigate } from "react-router-dom";
import Home from "../pages/home/home.js";
import Posts from "../pages/posts/posts.js";
import Post from "../pages/post/post.js";
import Colunista from "../pages/colunista/colunista.js";
import Materia from "../pages/materia/materia.js";
import Videos from "../pages/videos/videos.js";   
import QuemSomos from "../pages/quem-somos/quem-somos.js";
import Materias from "../pages/materias/materias.js";

export default function RoutesApp() {
  return (
    <Routes>
      
      <Route path="/" element={<Home />} />
      <Route path="/posts" element={<Posts />} />
      <Route path="/posts/:id_post" element={<Post />} />
      <Route path="/colunistas/:id_colunista/posts" element={<Colunista />} />
      <Route path="/materias/:id_materia" element={<Materia />} />
      <Route path="/materias" element={<Materias />} />

      {/* 🔥 NOVA ROTA */}
      <Route path="/videos" element={<Videos />} />
      <Route path="/quem-somos" element={<QuemSomos />} />

      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}
